import React from 'react';
import { Card, Typography, Grid } from '@material-ui/core';
import { BarChart } from '@material-ui/icons';
import { SimovsatStatusMovement } from '~/types';

interface StatusCardsProps {
  statusMovement: SimovsatStatusMovement[];
}

interface StatusConfig {
  status: string;
  label: string;
  color: string;
}

const STATUS_CONFIG: Record<string, StatusConfig> = {
  mover: {
    status: 'mover',
    label: 'mover',
    color: '#4CAF50', // Verde
  },
  ocioso: {
    status: 'ocioso',
    label: 'ocioso',
    color: '#FFEB3B', // Amarelo
  },
  pare: {
    status: 'pare',
    label: 'pare',
    color: '#F44336', // Vermelho
  },
  'off-line': {
    status: 'off-line',
    label: 'off-line',
    color: '#2196F3', // Azul
  },
  inativo: {
    status: 'inativo',
    label: 'inativo',
    color: '#E0E0E0', // Cinza claro
  },
  'nunca conectado': {
    status: 'nunca conectado',
    label: 'nunca conectado',
    color: '#9C27B0', // Roxo
  },
};

export default function StatusCards({ statusMovement }: StatusCardsProps) {
  const getStatusConfig = (status: string): StatusConfig => {
    return STATUS_CONFIG[status] || { status, label: status, color: '#757575' };
  };

  return (
    <div>
      <Typography variant='h6' style={{ fontWeight: 'bold', marginBottom: 20 }}>
        STATUS/MOVIMENTAÇÃO
      </Typography>
      <Grid container spacing={2}>
        {statusMovement.map((item, index) => {
          const config = getStatusConfig(item.status);
          return (
            <Grid item xs={12} sm={6} md={4} lg={2} key={index}>
              <Card
                style={{
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  borderRadius: 8,
                  overflow: 'hidden',
                }}
              >
                {/* Cabeçalho */}
                <div
                  style={{
                    backgroundColor: config.color,
                    padding: '12px 16px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8,
                    borderRadius: '8px 8px 0 0',
                  }}
                >
                  <BarChart style={{ color: '#fff' }} />
                  <Typography
                    variant='body1'
                    style={{
                      color: '#fff',
                      fontWeight: 'bold',
                      textTransform: 'capitalize',
                      fontSize: '14px',
                    }}
                  >
                    {config.label}
                  </Typography>
                </div>

                {/* Corpo */}
                <div
                  style={{
                    padding: '20px 16px',
                    textAlign: 'center',
                    backgroundColor: '#fff',
                    flex: 1,
                  }}
                >
                  <Typography
                    variant='h4'
                    style={{
                      fontWeight: 'bold',
                      color: '#333',
                      marginBottom: 8,
                    }}
                  >
                    {item.quantidade.toLocaleString('pt-BR')}
                  </Typography>
                  <Typography variant='body2' style={{ color: '#666', fontSize: '12px' }}>
                    VEÍCULO
                  </Typography>
                </div>

                {/* Rodapé */}
                <div
                  style={{
                    backgroundColor: config.color,
                    padding: '8px 16px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    borderRadius: '0 0 8px 8px',
                    cursor: 'pointer',
                  }}
                >
                  <Typography
                    variant='body2'
                    style={{
                      color: '#fff',
                      fontSize: '12px',
                      fontWeight: 'bold',
                    }}
                  >
                    detalhes
                  </Typography>
                  <span style={{ color: '#fff', fontSize: '16px' }}>✓</span>
                </div>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </div>
  );
}
